import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import examMasterService from "../../services/examMasterService";

export const fetchCompetitiveSubjects = createAsyncThunk(
  "competitiveSubjects/fetchCompetitiveSubjects",
  async (examId = null, { rejectWithValue }) => {
    try {
      return await examMasterService.getCompetitiveSubjects(examId);
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch competitive subjects");
    }
  }
);

export const createCompetitiveSubject = createAsyncThunk(
  "competitiveSubjects/createCompetitiveSubject",
  async (payload, { rejectWithValue }) => {
    try {
      const data = payload?.data || payload;
      const imageFile = payload?.imageFile || null;
      return await examMasterService.createCompetitiveSubject(data, imageFile);
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to create competitive subject");
    }
  }
);

export const updateCompetitiveSubject = createAsyncThunk(
  "competitiveSubjects/updateCompetitiveSubject",
  async ({ id, data, imageFile }, { rejectWithValue }) => {
    try {
      return await examMasterService.updateCompetitiveSubject(id, data, imageFile);
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to update competitive subject");
    }
  }
);

export const deleteCompetitiveSubject = createAsyncThunk(
  "competitiveSubjects/deleteCompetitiveSubject",
  async (id, { rejectWithValue }) => {
    try {
      await examMasterService.deleteCompetitiveSubject(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to delete competitive subject");
    }
  }
);

const competitiveSubjectSlice = createSlice({
  name: "competitiveSubjects",
  initialState: {
    competitiveSubjects: [],
    isLoading: false,
    error: null,
    success: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchCompetitiveSubjects.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchCompetitiveSubjects.fulfilled, (state, action) => {
        state.isLoading = false;
        state.competitiveSubjects = action.payload;
      })
      .addCase(fetchCompetitiveSubjects.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Create
      .addCase(createCompetitiveSubject.fulfilled, (state, action) => {
        state.competitiveSubjects.unshift(action.payload);
        state.success = "Competitive subject created successfully";
      })
      // Update
      .addCase(updateCompetitiveSubject.fulfilled, (state, action) => {
        const index = state.competitiveSubjects.findIndex(s => s.id === action.payload.id);
        if (index !== -1) {
          state.competitiveSubjects[index] = action.payload;
        }
        state.success = "Competitive subject updated successfully";
      })
      // Delete
      .addCase(deleteCompetitiveSubject.fulfilled, (state, action) => {
        state.competitiveSubjects = state.competitiveSubjects.filter(s => s.id !== action.payload);
        state.success = "Competitive subject deleted successfully";
      });
  },
});

export const { clearError, clearSuccess } = competitiveSubjectSlice.actions;
export default competitiveSubjectSlice.reducer;
